import { Component, input } from '@angular/core';
import type { ReportEntry } from '../../domain/final-report';
import { twoDigits } from '../../domain/format';

// Podium du rapport final : les trois premiers et leurs cibles eliminees.
// Visuellement 2e, 1er, 3e ; dans l'ordre du classement pour les lecteurs d'ecran.
@Component({
  selector: 'app-podium',
  styleUrl: './podium.scss',
  templateUrl: './podium.html',
})
export class Podium {
  readonly entries = input.required<ReportEntry[]>();

  protected readonly digits = twoDigits;
}
